module.exports = __webpack_public_path__ + "img/ISO9001-en.ec0792f5.jpg";